import React, { useState } from 'react';
import cn from 'classnames';

import CollapsibleBlock from '@components/common/CollapsibleBlock';

import { IActionMenu } from '@interfaces/components/table';

import styles from './CollapsibleActionsMenu.module.scss';

export interface ICollapsibleMenuActionItemParams<T> {
	label: string;
	name: string;
	items: IActionMenu<T>[];
}

interface ICollapsibleActionsMenuParams<T> {
	actions: ICollapsibleMenuActionItemParams<T>[];
	isVisibleMenu: boolean;
	onClick: (actionId: T) => void;
}

const CollapsibleActionsMenu = <T, >({
	actions,
	isVisibleMenu,
	onClick,
}: ICollapsibleActionsMenuParams<T>) => {
	const [openedCategoryName, setOpenedCategoryName] = useState('');

	const toggleCategory = (name: string) => {
		setOpenedCategoryName((prev) => {
			return prev === name ? '' : name;
		});
	};

	const onMenuItemClick = (action: IActionMenu<T>) => {
		if (action.disabled) return;

		onClick(action.id);
	};

	return (
		<div>
			{isVisibleMenu && (
				<div className={styles.menuWrapper}>
					{actions.length > 0 && actions.map((action) => {
						const isOpen = openedCategoryName === action.name;
						const categoryClassname = cn(styles.collapsibleBlockLabel, {
							[styles.collapsibleBlockLabelActive]: isOpen,
						});

						return (
							<CollapsibleBlock
								key={action.name}
								containerClassname={categoryClassname}
								isOpen={isOpen}
								label={action.label}
								name={action.name}
								toggleState={toggleCategory}
							>
								{action.items.map((action) => {
									return (
										<div
											key={action.text}
											className={cn(styles.menuItem, {
												[styles.disabled]: action.disabled,
											})}
											data-testid='action-item'
											onClick={() => onMenuItemClick(action)}
										>
											{action.text}
										</div>
									);
								})}
							</CollapsibleBlock>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default CollapsibleActionsMenu;
